module.exports = __webpack_public_path__ + "media/ruoyi_01_古镇时间.0d3cee7e.wav";